module.exports = __webpack_public_path__ + "static/media/RBG_art_Jesse_Harp.4b9e5dcb.jpg";